import { render, staticRenderFns } from "./media-uploader.vue?vue&type=template&id=d20bfd78&"
import script from "./media-uploader.vue?vue&type=script&lang=js&"
export * from "./media-uploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports